var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgJpgIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.4003 7.99998C14.4003 9.32546 15.4748 10.4 16.8003 10.4C18.1258 10.4 19.2003 9.32546 19.2003 7.99998C19.2003 6.67449 18.1258 5.59998 16.8003 5.59998C15.4748 5.59998 14.4003 6.67449 14.4003 7.99998ZM9.91223 11.326C9.77103 11.152 9.54463 11.1508 9.40423 11.32L9.40383 11.3196L4.06943 17.7212C3.93103 17.8868 3.99223 18.0268 4.21103 18.0268H19.7822C20.0002 18.0268 20.0706 17.8832 19.9374 17.7056L16.913 13.6728C16.7806 13.4964 16.5538 13.4868 16.4078 13.654L14.283 16.0868C14.1362 16.2544 13.9054 16.2488 13.7654 16.0768L9.91223 11.326Z",
    fill: "#637282"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJpgIcon);
export default __webpack_public_path__ + "static/media/jpg-icon.f106f0a9.svg";
export { ForwardRef as ReactComponent };